import * as z from 'zod';
export const StoredGroupSchema = z.object({
    id: z.uuidv7(),
    name: z.string().min(1),
    createdAt: z.number().int().nonnegative(),
    updatedAt: z.number().int().nonnegative(),
});
export const StoredVariationSchema = z.object({
    id: z.uuidv7(),
    value: z.string().min(1),
    displayValue: z.string().min(1),
    groupId: z.uuidv7(),
    createdAt: z.number().int().nonnegative(),
});
//# sourceMappingURL=group.js.map